import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 19 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "m12.474 10.984 5.73 5.73-1.49 1.49-5.73-5.73c-1.07.77-2.36 1.24-3.77 1.24a6.5 6.5 0 1 1 6.5-6.5c0 1.41-.47 2.7-1.24 3.77m-5.26-8.27c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }